import React from "react";
import "./FullReview.css";

import { NavLink } from "react-router-dom";

function FullReview({ loggedInUser, setCurrentUser, history, location }) {
  return (
    loggedInUser && (
      <main className="box">
        <div className="backMenuBox">
          <NavLink to="/profile/reviews">
            <img src="/images/back.png" />
          </NavLink>

          <h1>Your Reviews</h1>
        </div>

        <div className="scrollBox">
          <section className="reviewBox">
            <div  className="reviewInfoBox">
              <h2>{location.place.name}</h2>
              <p>{location.place.icon}</p>
              <div className="reviewDateBox">
                <p>{new Date(location.place.date).toDateString()}</p>
                <p className="reviewHourBox">{location.place.hour}</p>
              </div>
            </div>
          </section>

          <section className="fullReviewBox">
            <div className="fullTopReviewBoxFlex">
              <div className="fullTopReviewBox">
                <img src={loggedInUser.imageUrl} />
                <h3>{loggedInUser.username}</h3>
              </div>
              <div>
                <h1>{location.place.userRating}</h1>
              </div>
            </div>

            <div className="commentsReviewBox">
              <h4>{location.place.titleReview}</h4>

              <div className="commentsReview">
                <img src="/images/happyface.png" />
                <div className="commentsInputBox">
                  <p>{location.place.posReview}</p>
                </div>
              </div>

              <div className="commentsReview">
                <img src="/images/sadface.png" /> 
                
                <div className="commentsInputBox">
                  <p> {location.place.negReview}</p>
                </div>
              </div>
            </div>
          </section>
        </div>
      </main>
    )
  );
}

export default FullReview;
